module.exports = __webpack_public_path__ + "img/im_bringback_logo.1db7a998.svg";